module.exports = __webpack_public_path__ + "img/DW365-056.6e1dee46.jpg";